import { FetchResult } from 'apollo-link';
import { DataProxy } from 'apollo-cache';

import { Content, PostedToGroup, GetPostedToGroupsDocument } from 'api';
import { USER_FEED_ID } from 'constants/index';

interface IPostedToGroup extends PostedToGroup {
  __typename: string;
}

interface IReadQuery {
  contextGetPostedToGroups: IPostedToGroup[];
}

interface IReducer {
  cache: DataProxy;
  result: FetchResult;
}

export default (options: IReducer) => {
  const { cache, result } = options;
  const { contextGetPostedToGroups }: IReadQuery = cache.readQuery({
    query: GetPostedToGroupsDocument,
  });

  if (!contextGetPostedToGroups) {
    return;
  }

  const { processContent } = result.data;
  const { group_ids }: Content = processContent;

  const toLead = group_ids
    .filter(groupId => groupId !== USER_FEED_ID)
    .map(groupId => ({ group_id: groupId, score: -1, __typename: 'PostedToGroup' }));

  const toTrail = contextGetPostedToGroups.filter(postedToGroup => {
    return !group_ids.includes(postedToGroup.group_id);
  });

  const updatedPostedToGroups: IPostedToGroup[] = toLead.concat(toTrail);
  contextGetPostedToGroups.splice(0, contextGetPostedToGroups.length, ...updatedPostedToGroups);

  cache.writeQuery({
    query: GetPostedToGroupsDocument,
    variables: {},
    data: { contextGetPostedToGroups },
  });
};
